// extracted by mini-css-extract-plugin
export var hideEditor = "_lk-2";
export var infoIcon = "_lk-3";
export var label = "_lk-1";
export var labelContainer = "_lk-0";
export var readonlyText = "_lk-4";